import React from "react";

const CountDown = ({ hours = 0, minutes = 0, seconds = 0 }) => {
  const [time, setTime] = React.useState({
    hours: hours,
    minutes: minutes,
    seconds: seconds,
  });

  const tick = () => {
    if (time.minutes === 0 && time.seconds === 0)
      setTime({
        hours: time.hours - 1,
        minutes: 59,
        seconds: 59,
      });
    else if (time.seconds === 0)
      setTime({
        hours: time.hours,
        minutes: time.minutes - 1,
        seconds: 59,
      });
    else
      setTime({
        hours: time.hours,
        minutes: time.minutes,
        seconds: time.seconds - 1,
      });
  };

  React.useEffect(() => {
    let timerID = setInterval(() => tick(), 1000);
    return () => clearInterval(timerID);
  });

  return (
    <p className="text-3xl">{`${time.hours
      .toString()
      .padStart(2, "0")}:${time.minutes
      .toString()
      .padStart(2, "0")}:${time.seconds.toString().padStart(2, "0")}`}</p>
  );
};

export default CountDown;
